import { useQuery } from '@tanstack/react-query';
import { ActivityPointApi } from 'api/ApiHelper';
import { activityPointQueryKey } from 'queries/activityPoint/queryKey';

export const useGetActivitySummaryQuery = (yearMonthDay: string) =>
  useQuery({
    queryKey: activityPointQueryKey.activitySummary(yearMonthDay),
    queryFn: () => ActivityPointApi.getSummary(yearMonthDay),
    gcTime: 0,
    staleTime: 0,
  });
